// process.env.NODE_ENV === 'production'

const HASURA_URI = 'backend.prolendo.com/v1/graphql' // w/o protocol, not a real uri :)
export const HTTP_ENDPOINT = `https://${HASURA_URI}`
export const WS_ENDPOINT = `wss://${HASURA_URI}`

export const CONTACT_URL = 'http://prolendo.com/index.html#form4-1a'
